import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import OrganicHues from './pages/OrganicHues';
import GreenHorizon from './pages/GreenHorizon';
import EcoRoute from './pages/EcoRoute';
import WHeros from './pages/WHeros';
import RiseAndRolls from './pages/RiseAndRolls';
import Admin from './pages/Admin';
import BakingCalculator from './pages/BakingCalculator';
import FormulationCalculator from './pages/FormulationCalculator';
import AboutUs from './pages/AboutUs';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import ContactUs from './pages/ContactUs';
import Products from './pages/Products';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import Membership from './pages/Membership';
import AuthPage from './pages/AuthPage';
import Account from './pages/Account';
import Catering from './pages/Catering';
import Careers from './pages/Careers';
import { ImageProvider } from './hooks/useImages';
import { CartProvider } from './hooks/useCart';
import { AuthProvider } from './hooks/useAuth';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
      <CartProvider>
      <ImageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <CartDrawer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/catering" element={<Catering />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/account" element={<Account />} />
          <Route path="/organic-hues" element={<OrganicHues />} />
          <Route path="/green-horizon" element={<GreenHorizon />} />
          <Route path="/ecoroute" element={<EcoRoute />} />
          <Route path="/wheros" element={<WHeros />} />
          <Route path="/rise-and-rolls" element={<RiseAndRolls />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/calculator" element={<BakingCalculator />} />
          <Route path="/admin/formulation" element={<FormulationCalculator />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      </ImageProvider>
      </CartProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
